import { InfoButton } from "@tandemdiabetes/sugarmate-react-components"
import classNames from "classnames"
import styles from "./PasswordRequirements.module.scss"
import { usePolyglot } from "src/contexts"

const polyglotPrefix = "components.password.requirements."

interface Props {
  className?: string;
}

// this string is not translated
const symbols = "! # $ % & ‘ ( ) * + , - / : ; < = > ? @ [ ] ^ _ { | } ~"

export function PasswordRequirements(props: Props) {
  const { className } = props
  const polyglot = usePolyglot()

  return (
    <div
      className={classNames(
        styles.passwordRequirements,
        className,
      )}
    >
      <h3 className={styles.passwordRequirementsHeading}>
        {polyglot.t(`${polyglotPrefix}heading`)}
      </h3>
      <ul className={styles.passwordRequirementsList}>
        <li className={styles.passwordRequirement}>
          {polyglot.t(`${polyglotPrefix}character_requirement`)}
        </li>
        <li className={styles.passwordRequirement}>
          {polyglot.t(`${polyglotPrefix}number_requirement`)}
        </li>
        <li className={styles.passwordRequirement}>
          {polyglot.t(`${polyglotPrefix}lowercase_requirement`)}
        </li>
        <li className={styles.passwordRequirement}>
          {polyglot.t(`${polyglotPrefix}uppercase_requirement`)}
        </li>
        <li className={styles.passwordRequirement}>
          <div className={styles.passwordRequirementRow}>
            {polyglot.t(`${polyglotPrefix}symbol_requirement`)}
            <InfoButton title={polyglot.t(`${polyglotPrefix}symbol_tooltip_title`)}>
              {symbols}
            </InfoButton>
          </div>
        </li>
      </ul>
    </div>
  )
}
